import clsx from 'clsx'

import { scoreLevel } from '@/common/util/featureRewrite'

interface Props {
  score: number
  summary?: string
}

const SeoScoreCircle = ({ score, summary }: Props) => {
  const level = scoreLevel(score)
  const textClass =
    level === 'high' ? 'text-success' : level === 'mid' ? 'text-caution' : 'text-critical'

  const colorClass =
    level === 'high'
      ? 'border-success bg-fill-success-secondary text-success'
      : level === 'mid'
        ? 'border-yellow text-caution bg-surface-caution'
        : 'border-critical bg-fill-critical-secondary text-critical'

  return (
    <div className='border-secondary inline-flex items-center justify-center gap-4 self-stretch rounded-2xl border-r-8 border-l-8 p-6'>
      <div
        className={clsx(
          'inline-flex h-20 w-20 flex-col items-center justify-center gap-2 rounded-[999px] outline-2 -outline-offset-2',
          colorClass
        )}
      >
        <div className="justify-start font-['Roboto'] text-3xl leading-10 font-bold">{score}</div>
      </div>
      <div className='flex items-center justify-center'>
        <div
          className={clsx('justify-start font-["Roboto"] text-xl leading-6 font-bold', textClass)}
        >
          タイトルは魅力的だが
          <br />
          メタ説明とコンテンツ構造に課題あり
        </div>
      </div>
    </div>
  )
}

export default SeoScoreCircle
